module.exports = __webpack_public_path__ + "static/media/ESTRATEGIA  DE CONEXION LINKEDIN.b37024c9.xlsx";